// Copyright © 2026 ApexRuntime Labs by Shashi (https://github.com/spshah). All rights reserved.

import { ChevronLeft, ChevronRight } from 'lucide-react';
import { currentYear } from '../../utils/dates';

export function YearDropdown({ selectedYear, onChange }) {
  const min = 2021;
  const max = currentYear();

  return (
    <div className="inline-flex items-center gap-1 rounded-lg border border-gray-200 bg-white px-1">
      <button
        type="button"
        onClick={() => onChange(selectedYear - 1)}
        disabled={selectedYear <= min}
        className="p-1.5 rounded hover:bg-gray-100 disabled:opacity-30"
      >
        <ChevronLeft size={15} />
      </button>
      <span className="px-2 text-sm font-medium text-gray-800 min-w-[3.5rem] text-center">
        {selectedYear}
      </span>
      <button
        type="button"
        onClick={() => onChange(selectedYear + 1)}
        disabled={selectedYear >= max}
        className="p-1.5 rounded hover:bg-gray-100 disabled:opacity-30"
      >
        <ChevronRight size={15} />
      </button>
    </div>
  );
}
